<template>
    <div class="form-group has-effect" :class="{ 'is-invalid': invalid }">
        <div class="has-effect-input">
            <select
                v-model="selectedLocal"
                class="form-control custom-select"
                :class="[
                    { 'has-content': selectedOption },
                    { 'is-invalid': invalid }
                ]"
                :placeholder="text"
                :required="required"
            >
                <option
                    v-if="text && firstOption"
                    v-text="text"
                    disabled
                    value=""
                    :selected="selectedLocal === ('' || null)"
                />
                <option
                    v-for="(opt, idx) in options"
                    v-text="opt.label || opt"
                    :disabled="opt.disabled"
                    :key="idx"
                    :value="opt.value || opt"
                />
            </select>
            <span v-if="showLegend" v-text="text" class="dropdown-select-label form-label" />
        </div>
        <div v-if="invalid" v-text="invalid" class="invalid-feedback" />
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: false
        },
        options: {
            type: Array,
            required: true
        },
        selectedOption: {
            type: [String, Number],
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        invalid: {
            type: String,
            required: false
        },
        firstOption: {
            type: Boolean,
            default: true
        },
        showLegend: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        selectedLocal: {
            get() {
                return this.selectedOption ? this.selectedOption : ''
            },
            set(value) {
                this.$emit('onChange', value)
                this.$emit('change', value)
            }
        }
    }
}
</script>
